module.exports = __webpack_public_path__ + "img/document-50.5f27a954.svg";